<template>
  <div class="regist">
    <div class="background">
      <div class="name">还没有企业账号，立即注册体验</div>
    </div>
    <div class="content">
      <form id="form"></form>
      <form id="form1"></form>
      <div class="corpname-wrap"
        @click="$refs.corpName.focus()">
        <div class="corpname-text"
          :class="{'already': corpName}">企业名称:</div>
        <input type="text"
          v-model="corpName"
          @input="spaceFilter('corpName')"
          class="corpname"
          placeholder="请输入"
          maxlength="30"
          @focus="corpNameFocus=true"
          @blur="corpNameFocus=false"
          ref="corpName"
          form="form">
        <div class="corpname-line-gray"></div>
        <div class="corpname-line"
          :class="corpNameFocus === true ? 'active' : ''"></div>
      </div>
      <div class="name-wrap"
        @click="$refs.name.focus()">
        <div class="name-text"
          :class="{'already': name}">联系人姓名:</div>
        <input type="text"
          v-model="name"
          @input="spaceFilter('name')"
          class="name"
          placeholder="请输入"
          maxlength="32"
          @focus="nameFocus=true"
          @blur="nameFocus=false"
          ref="name"
          form="form" />
        <div class="name-line-gray"></div>
        <div class="name-line"
          :class="nameFocus === true ? 'active' : ''"></div>
      </div>
      <!--兼容微信浏览器的password bug-->
      <input type="text"
        style="position:fixed;top:-9999px;left:-9999px;">
      <div class="password-wrap"
        @click="$refs.password.focus()">
        <div class="password-text"
          :class="{'already': password}">登录密码:</div>
        <input type="password"
          v-model="password"
          class="password"
          placeholder="请输入"
          maxlength="18"
          @focus="passwordFocus = true"
          @blur="passwordBlurHandle"
          ref="password">
        <div class="password-line-gray"></div>
        <div class="password-line"
          :class="passwordFocus === true ? 'active' : ''"></div>
      </div>
      <!-- <img :src="bindQrCodeUrl"
        class="qrcode"
        :class="{'hidden': !bindQrCodeUrl}"> -->
      <!-- <div class="tip">
        <p v-if="!timeout && !bindSuccess">扫码绑定微信，关注完成后请用此微信登录管理平台</p>
        <p v-if="timeout"
          class="timeout">二维码已过期 <span @click="getQrCode">刷新</span></p>
        <p v-if="bindSuccess"
          class="bind-success">绑定微信成功</p>
      </div> -->
      <div class="next-btn"
        :class="unclickable ? 'unclickable' : ''"
        @click="confirm">&#xe678;</div>
    </div>
  </div>
</template>

<script>
import md5 from 'md5';
export default {
  data() {
    return {
      corpName: '',
      name: '',
      password: '',
      corpNameFocus: false,
      nameFocus: false,
      passwordFocus: false,
      timeout: false,
      bindQrCodeId: '',
      bindQrCodeUrl: '',
      bindSuccess: false,
      loaded: false,
    };
  },
  computed: {
    unclickable() {
      return !this.corpName || !this.name || !this.password;
    },
  },
  methods: {
    spaceFilter(name) {
      if (name === 'phone') {
        this[name] = this[name].replace(/\D/g, '');
      } else {
        this[name] = this[name].replace(/\s/g, '');
      }
    },
    passwordFocusHandle(e) {
      this.passwordFocus = true;
      e.target.type = 'password';
    },
    passwordBlurHandle(e) {
      this.passwordFocus = false;
    },
    confirm() {
      if (this.unclickable) return false;
      if (/^[\u4e00-\u9fa5A-Za-z0-9-\_\(\)\（\）]+$/.test(this.corpName) === false) {
        this._notification('企业名称由1-30个中文、英文、数字及合法字符组成');
      } else {
        this._fetch('/gw/salaryssoapi/login/reg', {
          mobile: sessionStorage.getItem('phone'),
          corpName: this.corpName,
          userName: this.name,
          smsCode: '',
          password: md5(this.password),
          // bindQrCodeId: this.bindQrCodeId,
          unionid: this.$route.query.unionid,
          from: 'wx',
        }).then((res) => {
          if (res.success === true) {
            this.$router.push({
              path: '/registSuccess',
            });
          }
        });
      }
    },
    async getQrCode() {
      await this._fetch('/gw/minapp/wx/redirect/wx08b6f097671bbd9b/getBindQrCode').then((res) => {
        if (res.success) {
          this.bindQrCodeId = res.data.bindQrCodeId;
          this.bindQrCodeUrl = res.data.bindQrCodeUrl;
        }
      });
      this.resetStatus();
      const interval = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(interval);
          this.timeout = true;
        }
        this._fetch('/gw/minapp/wx/redirect/wx08b6f097671bbd9b/checkBindQrCodeState', {
          bindQrCodeId: this.bindQrCodeId,
        }).then((res) => {
          if (res.success) {
            clearInterval(interval);
            this.bindSuccess = true;
          } else {
            this.countdown--;
          }
        });
      }, 1000);
    },
    resetStatus() {
      this.bindSuccess = false;
      this.timeout = false;
      this.countdown = 300;
    },
  },
  mounted() {
    // this.getQrCode();
  },
};
</script>

<style scoped lang="stylus">
@import '~@css/mixins.styl'
.regist
  height 100%
  background #EFEFF4
  .background
    height 400px
    background #0082EF
    position relative
    &:before
      content ''
      width 100px
      height 20px
      position absolute
      left 0
      bottom 0
      transform-origin 0 100%
      transform rotateZ(30deg)
      background #0082EF
    &:after
      content ''
      width 100px
      height 20px
      position absolute
      right 0
      bottom 0
      transform-origin 100% 100%
      transform rotateZ(-30deg)
      background #0082EF
    .name
      width 100%
      line-height 46px
      font-size 34px
      color #fff
      text-align center
      absolute top 40px
  .content
    position relative
    width 690px
    height 654px
    background #fff
    border-radius 8px
    box-shadow 0px 4px 20px 0px rgba(39, 134, 243, 0.25)
    margin -280px auto 0
    box-sizing border-box
    padding 60px 26px 0
    .corpname-text
      line-height 36px
      font-size 28px
      color #111111
      position relative
      &.already
        color #A2A3B5
    .corpname
      height 44px
      line-height 44px
      font-size 30px
      margin-top 20px
      border none
      outline none
    .corpname-line-gray
      height 1px
      background-color #D9D9D9
      margin-top 16px
    .corpname-line
      height 1px
      background-color #0082EF
      transform scaleX(0)
      margin-top -1px
      transition transform 0.45s cubic-bezier(0.23, 1, 0.32, 1)
      &.active
        transform scaleX(1)
    .name-text
      line-height 36px
      font-size 28px
      color #111111
      margin-top 40px
      position relative
      &.already
        color #A2A3B5
    .name
      height 44px
      line-height 44px
      font-size 30px
      margin-top 20px
      border none
      outline none
    .name-line-gray
      height 1px
      background-color #D9D9D9
      margin-top 16px
    .name-line
      height 1px
      background-color #0082EF
      transform scaleX(0)
      margin-top -1px
      transition transform 0.45s cubic-bezier(0.23, 1, 0.32, 1)
      &.active
        transform scaleX(1)
    .password-text
      line-height 36px
      font-size 28px
      color #111111
      margin-top 40px
      position relative
      &.already
        color #A2A3B5
    .password
      height 44px
      line-height 44px
      font-size 30px
      margin-top 20px
      border none
      outline none
    .password-line-gray
      height 1px
      background-color #D9D9D9
      margin-top 16px
    .password-line
      height 1px
      background-color #0082EF
      transform scaleX(0)
      margin-top -1px
      transition transform 0.45s cubic-bezier(0.23, 1, 0.32, 1)
      &.active
        transform scaleX(1)
    .qrcode
      width 240px
      bporder 1px solid #9F9F9F
      absolute left 37px bottom 60px
    .tip
      width 340px
      height 240px
      absolute bottom 60px left 303px
      display flex
      align-items center
      line-height 36px
      font-size 28px
      color #111111
      p
        span
          color #1890FF
        &.timeout, &.bind-success
          margin-left 44px
          position relative
          &:before
            content ''
            width 36px
            height @width
            position absolute
            top 0px
            left -48px
            background url('../assets/imgs/warn.png') 0 0 no-repeat
            background-size 100% 100%
        &.bind-success:before
          background-image url('../assets/imgs/success.png')
  .next-btn
    width 100px
    height @width
    line-height @height
    background-color #0082EF
    border-radius 50%
    absolute right 0px bottom 0px
    transform translateY(140px)
    font-family iconfont
    color #fff
    font-size 36px
    text-align center
    text-indent 5px
    &.unclickable
      background-color #77B8F1
</style>
